import React, { useCallback, useEffect, useMemo, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from 'react-router-dom';
import UploadIcon from '@mui/icons-material/Upload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import { getCustomerList, uploadCustomerExcel, loggedInUserUrls, activeDeactiveCustomer } from '../../../services/index';
import toast, { Toaster } from 'react-hot-toast';
import Cookies from 'universal-cookie';
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { BASE_URL_INVENTORY, CUSTOMER_URL, DOWNLOAD_CUSTOMER_URL } from '../../../CONSTANTS';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import Loader from '../../Common/Loader';
import PaginationDataTable from '../../Common/PaginationDataTable';

const CustomerList = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});

    const [refresh, setRefresh] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);

    const [file1, setFile1] = useState({
        fileBase64: '',
        fileName: '',
    });

    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState('');
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);
    const countPerPage = 10;

    let navigate = useNavigate();

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const handleActiveInactive = (row) => {
        activeDeactiveCustomer(row.recordId).then((res) => {
            if (res.errorCode === 0) {
                setRefresh(!refresh);
                toast(res.message);
            } else {
                toast(res.message);
                return;
            }
        });
    };

    const columns = useMemo(() => [
        {
            name: 'NAME',
            selector: (row) => row.title,
        },
        {
            name: 'EMAIL',
            selector: (row) => row.email,
        },
        {
            name: 'WORK PHONE',
            selector: (row) => row.phone,
        },
        {
            name: 'ITEM PRICE LIST',
            selector: (row) => row?.priceListTitle
        },
        {
            name: 'ACTION',
            selector: (row) => (
                <div>
                    <EditIcon
                        style={{ fontSize: '15px', cursor: 'pointer' }}
                        onClick={() => {
                            navigate('/contacts/' + row.recordId + '/edit');
                        }}
                    />
                    &nbsp;&nbsp;
                    {row.active ? (
                        <CheckCircleIcon
                            style={{
                                fontSize: '15px',
                                cursor: 'pointer',
                                color: 'greenyellow',
                            }}
                            onClick={() => handleActiveInactive(row)}
                        />
                    ) : (
                        <CancelIcon style={{ fontSize: '15px', cursor: 'pointer', color: 'tomato' }} onClick={() => handleActiveInactive(row)} />
                    )}
                </div>
            ),
        },
    ], [handleRefresh]
    )

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const handleFileRead = async (event) => {
        const file = event.target.files[0];
        const base64 = await convertBase64(file);
        const base = base64.split(',')[1];
        setFile1({
            fileBase64: base,
            fileName: file.name,
        });
    };

    const handleUpload = () => {
        uploadCustomerExcel(file1).then((res) => {
            if (res.errorCode === 0) {
                toast(res.message);
            } else {
                setError(res);
                setShow2(true);
            }
        });
        setTimeout(handleClose(), 6000);
    };

    const [userData, setUserData] = useState('');
    const [urlList, setUrlList] = useState('');
    const [userRights, setUserRights] = useState('');

    useEffect(() => {
        let loginData1 = new Cookies().get('loginData1');
        setUserData(new Cookies().get('loginData1'));
        let id = loginData1.recordId;

        loggedInUserUrls().then((res) => {
            if (res.errorCode === 0) {
                setUrlList(res.responsePacket.urlList);
                setUserRights(res.responsePacket);
            } else {
                toast.error(res.message);
            }
        });
    }, []);

    const handleWarn = () => {
        toast('Access Denied!');
        return;
    };

    return (
        <>
            <Modal show={show2} onHide={handleClose2}>
                <Modal.Body>
                    <div>{error.message}</div>
                    <br />
                    {error.listOfErrors && error.listOfErrors?.map((item, i) => <div key={i}>{item}</div>)}
                </Modal.Body>
            </Modal>
            <div className='fill list-header d-print-none'>
                <Modal show={show} onHide={handleClose} size='sm'>
                    <Modal.Body>
                        <input
                            autoComplete='off'
                            className='ember-text-field ember-view form-control '
                            id='originalFileName'
                            type='file'
                            inputProps={{
                                accept: 'image/*, .xlsx, .xls, .csv, .pdf, .pptx, .pptm, .ppt',
                            }}
                            required
                            label='Document'
                            name='originalFileName'
                            onChange={(e) => handleFileRead(e)}
                            size='small'
                            variant='standard'
                        />
                    </Modal.Body>

                    <Modal.Footer>
                        {userRights.adminRoleEnum === 'ROLE_SUPER_ADMIN' || (urlList && urlList.some((data) => data.url === '/customer/downloadCustomerExcel')) ? (
                            <a href={`${BASE_URL_INVENTORY}` + `${DOWNLOAD_CUSTOMER_URL}`} target='_blank' download>
                                <Button variant='primary'>
                                    <DownloadIcon /> Download
                                </Button>
                            </a>
                        ) : (
                            <Button variant='secondary' onClick={handleWarn}>
                                <DownloadIcon /> Download
                            </Button>
                        )}

                        {userRights.adminRoleEnum === 'ROLE_SUPER_ADMIN' || (urlList && urlList.some((data) => data.url === '/customer/uploadPriceExcel/')) ? (
                            <Button variant='primary' onClick={handleUpload}>
                                <UploadIcon /> Upload
                            </Button>
                        ) : (
                            <Button variant='secondary' onClick={handleWarn}>
                                <UploadIcon /> Upload
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal>
            </div>
            <div className='vendorlistDataTable' style={{ height: 500, width: '100%' }}>
                <div className="excel-postn mt-2">
                    <div className="d-flex align-items-center">
                        <Button variant='primary' onClick={handleShow} className='py-2 tooltip-container ember-view btn btn-primary d-flex align-items-center'>
                            <ImportExportIcon /> Excel
                        </Button>
                        <Link to='/contacts/new'>
                            <Button id='ember5839' className='py-2 tooltip-container ember-view btn btn-primary d-flex align-items-center' type='button'>
                                <AddIcon />
                                New
                            </Button>
                        </Link>
                    </div>
                </div>
                <PaginationDataTable
                    paginationUrl={CUSTOMER_URL() + "getAllRecords"}
                    serverSidePagination={true}
                    search={true}
                    pagination={false}
                    className="position-relative"
                    columns={columns}
                    showNewBtn={true} onRowClicked={(data) => {
                        navigate('/contacts/' + data.recordId);
                    }}
                />
            </div>
            <Toaster />
        </>
    );
};

export default CustomerList;
